import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/shared/components/ui/tabs';
import { Toolbar } from '@/shared/components/custom/toolbar';
import { ProjectTimeReport } from '../components/ProjectTimeReport';
import { UserTimeReport } from '../components/UserTimeReport';
import { FeatureErrorBoundary } from '@/core/error-boundaries/public';
import { sentryReporter } from '@/core/observability/public';

export default function ReportsPage() {
  const { t } = useTranslation('reports');

  return (
    <FeatureErrorBoundary reporter={sentryReporter}>
      <div data-testid="reports-page">
        <Toolbar className="pt-0">
          <Toolbar.Info title={t('page.title')} description={t('page.subtitle')} />
        </Toolbar>

        <Tabs defaultValue="project">
          <TabsList>
            <TabsTrigger value="project" data-testid="reports-tab-project">
              {t('tabs.byProject')}
            </TabsTrigger>
            <TabsTrigger value="user" data-testid="reports-tab-user">
              {t('tabs.byUser')}
            </TabsTrigger>
          </TabsList>
          <TabsContent value="project" className="mt-4">
            <ProjectTimeReport />
          </TabsContent>
          <TabsContent value="user" className="mt-4">
            <UserTimeReport />
          </TabsContent>
        </Tabs>
      </div>
    </FeatureErrorBoundary>
  );
}
